























































































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Vue, Prop, Component} from 'vue-property-decorator';
import axios from 'axios';
import {Ax} from "@/utils";
import VueElementLoading from "vue-element-loading";
import popUp from "@/modules/budget/monitoring/input-forms/components/popUp.vue";
import ReasonInputApp1214 from "@/modules/budget/monitoring/input-forms/components/application12/ReasonInputApp12_14.vue";
import { noAbc, nextInput } from "@/modules/budget/monitoring/input-forms/common/formaters"

@Component({
    components: {
        'reason-input': ReasonInputApp1214,
        'loading': VueElementLoading,
        'pop-up': popUp,
    }
})
export default class application12_14 extends Vue {
    @Prop({
        required: false,
        default: ''
    })
    private user_id!:any;
    @Prop({
        required: false,
        default: 1000, // Set the desired default here
    })
    private convert!:any;
    @Prop({
        required: true,
        default: null
    })
    private currForm!:any;
    @Prop({
        required: true,
        default: null
    })
    private reportFormView!:any;
    @Prop({
        required: true,
        default: null
    })
    private editAccess!:any;
    @Prop({
        required: true,
        default: null
    })
    private deleteAccess!:any;
    @Prop({
        required: true,
        default: []
    })
    private reasonsFull!:any[];
    @Prop({
        required: true,
        default: {}
    })
    private dictReasons!:any;
    @Prop({
        required: true,
        default: 0
    })
    private childStatus!:any;

    private tableData: any[] = [];
    private treeData: any[] = [];
    private creditsData: any[] = [];
    private curProgData: any[] = [];
    private devProgData: any[] = [];

    private tr_path = 'modules.budget_execution_monitoring.reports.app12_14'

    private projectsDict:any = {};
    private cols = `
        Код КБК ---- func
        Проект/Наименование ---- expense_code
        Утвержденный бюджет ---- utv_plan_year
        Уточненный бюджет ----: refined_plan :[app12, ap14rb, app12cons,app14rbcons, app18]editable:  refined_plan ----- [app14ob, app14obcons]not_editable: /utv_utoch_references
        Скорректированный бюджет ---- adjusted_plan [app12, ap14rb, app12cons,app14rbcons, app18]editable:  adjusted_plan ----- [app14ob, app14obcons]not_editable: /scor_plan_plat_year
        Выделено/ за счет трансф/Выделено из ОБ ----allocated_budget: [app12, ap14rb, app12cons,app14rbcons, app18]editable:  allocated_budget ----- [app14ob, app14obcons]not_editable: /scor_plan_plat
        План по платежам ----finance_plan: [app12, ap14rb, app12cons,app14rbcons, app18]editable:  finance_plan  ----- [app14ob, app14obcons]not_editable: /scor_plan_plat
        Принятые обязательства ---- summa_dog
        Непринятые обязательства ---- sum_discarded_oblig = summa_dog - scor_plan_obaz_period - utv_plan_obaz_period
        Оплаченные обязательства ---- pay_amount
        Ожидаемое исполнение плана на год ---- expected_plan : editable[lowest]
        Ожидаемое неисполнение плана на год ---- expected_plan_year = expected_plan - scor_plan_plat_period
        Сумма неисполнения ---- nonexec = pay_amount - allocated_budget
        Экономия бюджетных средств ---- reason_sum_1
        Неосвоение за отчетный период ---- sum_unspent
        Причины неосвоения за отчетный период ---- reason_type_1
        Причины несвоевременного принятия либо непринятия обязательств ---- reason_type_2
        Причины ожидаемого неосвоения плана на год ---- reason_type_3
        Всего ---- total какойто
    `

    private get tableFields() {
        if (this.reportFormView) {
            return [
                'func', // anal
                'expense_code', // anal
                'utv_plan_year', // anal 1
                'refined_plan', // anal 2
                'adjusted_plan', // anal 3
                'allocated_budget', // anal 4
                'finance_plan', // anal 5
                'summa_dog', // anal 6
                'sum_discarded_oblig', // anal 7 // summa_dog - scor_plan_plat_year
                'pay_amount', // anal 8
                'expected_plan', // anal 9
                'expected_plan_year', // anal 10 // expected_plan - scor_plan_plat_period
                'nonexec', // anal 11  // pay_amount - allocated_budget
                'reason_sum_1', // anal 12
                'sum_unspent' // anal 13
            ]
        } else {
            return [
                'func', // reasons
                'expense_code', // reasons
                'expected_plan_year', // reasons 1
                'nonexec', // reasons 2
                'sum_discarded_oblig', // reasons 3
                'reason_sum_1', // reasons 4
                'sum_unspent', // reasons 5
                'reason_type_1', // reasons 6
                'reason_type_2', // reasons 7
                'reason_type_3' // reasons 8
            ] // reasons
        }
    }
    private numCols: string[] = [
        'utv_plan_year',
        'refined_plan',
        'adjusted_plan',
        'allocated_budget',
        'finance_plan',
        'summa_dog',
        'sum_discarded_oblig',
        'pay_amount',
        'expected_plan',
        'expected_plan_year',
        'nonexec',
        'reason_sum_1',
        'sum_unspent',
        'reason_type_1',
        'reason_type_2',
        'reason_type_3'
    ]
    private inputFields: string[] = [
        'refined_plan',
        'adjusted_plan',
        'allocated_budget',
        'finance_plan',
        'expected_plan',
    ]
    private flk_keys: any = {
        reason_type_1: 'nonexec',
        reason_type_2: 'expected_plan_year',
        reason_type_3: 'sum_discarded_oblig'
    }
    private is_editable_field(field: string): boolean {
        if (['refined_plan', 'adjusted_plan', 'allocated_budget', 'finance_plan'].includes(field) && ['app14_ob', 'app14cons_ob'].includes(this.currForm.form_code)) {
            return false;
        }
        return true
    }
    private reasonFields:any[] = ['reason_type_1', 'reason_type_2', 'reason_type_3']

    private loading: boolean = false;
    private showReasonInput: boolean = false;
    private inputModelType: number = 1;

    // EAK-1299: баннер о проектах, переданных на исполнение МСУ
    private msuTransfers: any[] = [];
    private msuListOpen: boolean = false;

    // считаются проекты, а не строки списка: у проекта может быть несколько КБК МСУ
    private get msuProjectCount(): number {
        return new Set(this.msuTransfers.map((v: any) => v.expense_code)).size
    }

    private get msuProblemCount(): number {
        return new Set(this.msuTransfers.filter((v: any) => v.state !== 'ok').map((v: any) => v.expense_code)).size
    }

    // форма района (XXYY01) или свод района (XXYY00) Приложения 14 ОБ
    private get isDistrictObForm(): boolean {
        if (!this.currForm || !['app14_ob', 'app14cons_ob'].includes(this.currForm.form_code)) {
            return false
        }
        const region = String(this.currForm.region || '')
        if (region.length !== 6 || region.substring(2, 4) === '01') {
            return false
        }
        return region.substring(4) === (this.currForm.form_code === 'app14cons_ob' ? '00' : '01')
    }

    private async loadMsuTransfers() {
        if (!this.isDistrictObForm) {
            this.msuTransfers = []
            return
        }
        const params: any = {
            'currForm': this.currForm,
            'status': 0,
            'user_id': this.user_id,
        }
        await axios.post('/api-py/application/input-forms/409/msu-transfers', params, {withCredentials: true}).then(resp => {
            if (resp.status === 200 && Array.isArray(resp.data)) {
                this.msuTransfers = resp.data
            }
        }).catch(() => {
            this.msuTransfers = []
        })
    }

    private msuLocaleName(item: any, field: string): string {
        const locale = this.$i18n.locale === 'kk' ? 'kk' : 'ru'
        return item[`${field}_${locale}`] || item[`${field}_ru`] || ''
    }

    private msuStateText(state: string): string {
        const scope = this.currForm.form_code === 'app14cons_ob' ? 'cons' : 'district'
        const key = state === 'no_ipf' ? 'state_no_ipf' : `state_${state}_${scope}`
        return this.$t(`${this.tr_path}.msu_banner.${key}`).toString()
    }


    private async created() {
        this.$emit('onRegisterFacade', this)
    }

    private async mounted() {
        await this.loadData()
        await this.updateFormFlk()
    }

    private total(table: any[], f: string) {
        let sum = 0
        for (const el of table) {
            sum += el[f]
        }
        return sum
    }

    private async getData(load_iisk: boolean = false) {
        let data:any[] = []
        const params:any = {
            'currForm': this.currForm,
            'status': 0,
            'load_iisk': load_iisk,
            'convert': this.convert,
            'user_id': this.user_id,
        }
        this.loading = true
        await axios.post('/api-py/application/input-forms/409/data', params, {withCredentials: true}).then(resp => {
            if (resp.status === 200) {
                data = resp.data
                this.loading = false
            }
        }).catch(() => {
            this.loading = false
        })
        return data
    }
    private async loadData(load_iisk: boolean = false) {
        this.tableData = [];
        this.treeData = [];
        this.loadMsuTransfers();
        const data:any[] = await this.getData(load_iisk);
        this.tableData = this.createTree(data)
        this.curProgData = this.tableData.filter(v => v.dev_type === 0)
        this.devProgData = this.tableData.filter(v => v.dev_type === 1)
        this.creditsData = this.tableData.filter(v => v.dev_type === 2)
    }
    private async refreshData() {
        let returnVal = false
        await this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.reports.app12_14.warn_refresh_data').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    this.loadData(true)
                    this.updateFormFlk()
                    this.saveData({load_data: false})
                } else {
                    returnVal = false
                }
            })
            .catch(error => {
                this.makeToast('danger', this.$t('modules.srs.warnings.error'), error.toString());
            });
    }

    private createTree(tableData: any[]) {
        const tree: any = {}
        for (const item of tableData) {
            const node: any = Object.assign({}, item);
            let pprNode:any = tree[item.func]
            if (!pprNode) {
                pprNode = Object.assign({collapse: false, child_list: []}, item)
                tree[item.func] = pprNode
                this.calcFields(pprNode, true)
            }
            this.calcFields(node)
            pprNode.child_list.push(node)
            this.treeData.push(node)

        }

        return Object.values(tree)
    }
    private async saveData(options: any = {load_data: true}) {
        const flk_rows: any[] = []
        const dataSet:any[] = []
        for (const item of this.treeData) {
            if (item.flkS1 || item.flkS2) {
                flk_rows.push(`${item.func}:${item.expense_code}`)
                continue
            }
            dataSet.push(item)
        }
        if (flk_rows.length) {
            this.makeToast(
                'danger',
                this.$t('modules.common.error'),
                this.$t('modules.budget_execution_monitoring.reports.app_9.warn_non_exec_flk')
                    .toString()
                    .replace('$cbc', flk_rows.join(', '))
            )
        }
        const params: any = {
            'currForm': this.currForm,
            'save_list': dataSet,
            'user_id': this.user_id
        }
        await axios.post('/api-py/application/input-forms/409/data/save', params).then(res => {
            if (res.status === 200) {
                if (options.load_data ?? options.load_data === undefined) {
                    this.loadData()
                    this.updateFormFlk()
                    this.makeToast('success', this.$t('modules.common.saving'), this.$t('modules.common.data_saved_successfully'))
                }
            }
        })
    }
    private downloadRep(rep_type:number = 1) {
        this.loading = true
        const request:any = {
            'currForm': this.currForm,
            'status': 0,
            'report_type': rep_type,
            'is_rb': rep_type === 2,
            'locale': this.$i18n.locale,
            'convert': this.convert,
            'user_id': this.user_id
        }
        const that = this
        const form_code = this.currForm.form_code
        try {
            this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'));
            Ax(
                {
                    url: `/api-py/application/input-forms/409/report`,
                    method: 'POST',
                    responseType: 'blob',
                    data: request
                },
                (data: any) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let suffix: string = ''
                    if (form_code === 'app18' && rep_type === 20) {
                        suffix = '_p20'
                    } else if (rep_type === 2) {
                        suffix = '_rb'
                    }
                    let name = this.$t(`${this.tr_path}.download_rep.name_${form_code}${suffix}`).toString()
                    if (['app14_ob', 'app14cons_ob'].includes(form_code)) {
                        let pmonth = this.currForm.month - 1
                        let pyear= this.currForm.year
                        if (pmonth < 0) {
                            pyear = pyear - 1
                            pmonth = 11
                        }
                        name = name.replace('$date', `01.${(pmonth + 1).toString().padStart(2, '0')}.${pyear}`)
                    }
                    link.setAttribute('download', name + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    that.loading = false
                },
                (error) => {
                    that.loading = false
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                }
            );
        } catch (error) {
            that.loading = false
            this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_filter'));
        }
    }

    private flkFunc(item: any, reason: string) {
        let rsum = 0
        for (const r in item[reason]) {
            rsum += item[reason][r]
        }
        return parseFloat(rsum.toFixed(3)) !== parseFloat(item[this.flk_keys[reason]].toFixed(3))
    }
    private flk0t(item: any, field: string) {
        return item[field] <= 0
    }
    private flkS1(item: any) {
        // "Ожидаемое исполнение на год" < "оплаченные обязательства"
        return (item.expected_plan.toFixed(3)) < parseFloat(item.pay_amount.toFixed(3))
    }
    private flkS2(item: any) {
        //"Скорректированный план на год" < "ожидаемое исполнение на год"
        return parseFloat(item.expected_plan.toFixed(3)) > parseFloat(item.adjusted_plan.toFixed(3))
    }
    private showPopup(el: any, f:string) {
        if (f === 'allocated_budget') {
            return el.flk1t
        } else if (f === 'finance_plan') {
            return el.flk2t
        } else if (f === 'pay_amount') {
            return el.flkS1
        } else if (f === 'adjusted_plan') {
            return el.flkS2
        } else if (f === 'expected_plan') {
            return el.flkS1 || el.flkS2 || el.flk3t
        }
        return false
    }
    private showPopupText(el: any, f:string) {
        if (f === 'allocated_budget') {
            return el.flk1t ? this.$t(`${this.tr_path}.warn_sum_le_zero_allocated_budget`): ''
        } else if (f === 'finance_plan') {
            return el.flk2t ? this.$t(`${this.tr_path}.warn_sum_le_zero_finance_plan`): ''
        } else if (f === 'pay_amount') {
            return el.flkS1 ? this.$t(`${this.tr_path}.warn_sum_pay_amount`): ''
        } else if (f === 'adjusted_plan') {
            return el.flkS2 ? this.$t(`${this.tr_path}.warn_sum_adjusted_plan`): ''
        } else if (f === 'expected_plan') {
            if (el.flk3t) {
                return this.$t(`${this.tr_path}.warn_sum_le_zero_expected_plan`)
            } else if (el.flkS2) {
                return this.$t(`${this.tr_path}.warn_sum_adjusted_plan`)
            } else if (el.flkS1) {
                return this.$t(`${this.tr_path}.warn_sum_pay_amount`)
            }
        }
        return ''
    }

    private reSum(item: any, field: string) {
        let sum = 0
        for (const el of item.child_list) {
            sum += el[field]
        }
        return parseFloat(sum.toFixed(3))
    }
    private calcFields(item: any, sum = false) {
        const that = this;
        const sumFields: string[] = ['utv_plan_year', 'refined_plan', 'adjusted_plan', 'allocated_budget', 'finance_plan', 'summa_dog', 'sum_discarded_oblig', 'pay_amount', 'expected_plan', 'expected_plan_year', 'nonexec', 'reason_sum_1', 'sum_unspent']
        const pft3 = (v:number) => parseFloat(v.toFixed(3))

        if (!sum) {
            item['_adjusted_plan'] = item.adjusted_plan
            Object.defineProperties(item, {
                'adjusted_plan': {
                    get: function () {
                        return item._adjusted_plan
                    },
                    set: function (val) {
                        item._adjusted_plan = val
                    }
                },
                'sum_discarded_oblig': {
                    get: function() {
                        return pft3(item.summa_dog - item.scor_plan_obaz_period - item.utv_plan_obaz_period)
                    }
                },
                'expected_plan_year': {
                    get: function() {
                        return pft3(item.expected_plan - item.adjusted_plan)
                    }
                },
                'nonexec': {
                    get: function() {
                        return pft3(item.pay_amount - item.allocated_budget)
                    }
                },
                'reason_sum_1': {
                    get: function() {
                        let sum = 0
                        for (const r in item.reason_type_1) {
                            if ([1, 2, 3].includes(that.dictReasons[r].gr_pl_id)) {
                                sum += item.reason_type_1[r]
                            }
                        }
                        return parseFloat(sum.toFixed(3))
                    }
                },
                'sum_unspent': {
                    get: function() {
                        return item.nonexec - item.reason_sum_1
                    }
                },
                'project_name': {
                    get: function() {
                        let txt = `${item.expense_code}`
                        if (item.expense_code in that.projectsDict) {
                            const name = that.projectsDict[item.expense_code][`name_${that.$i18n.locale}`]
                            if (name) {
                                txt += ` - ${name}`
                            }
                        }
                        return txt
                    }
                },
                'flk1': {
                    get: function() {
                        return that.flkFunc(item, 'reason_type_1')
                    }
                },
                'flk2': {
                    get: function() {
                        return that.flkFunc(item, 'reason_type_2')
                    }
                },
                'flk3': {
                    get: function() {
                        return that.flkFunc(item, 'reason_type_3')
                    }
                },
                'flk1t': {
                    get: function() {
                        return that.flk0t(item, 'allocated_budget') && (!['app14_ob', 'app14cons_ob'].includes(that.currForm.form_code))
                    }
                },
                'flk2t': {
                    get: function() {
                        return that.flk0t(item, 'finance_plan') && (!['app14_ob', 'app14cons_ob'].includes(that.currForm.form_code))
                    }
                },
                'flk3t': {
                    get: function() {
                        return that.flk0t(item, 'expected_plan')
                    }
                },
                'flkS1': {
                    get: function() {
                        return that.flkS1(item)
                    }
                },
                'flkS2': {
                    get: function() {
                        return that.flkS2(item)
                    }
                },

                'flk': {
                    get: function() {
                        return item.flk1 || item.flk2 || item.flk3 || item.flk1t || item.flk2t || item.flk3t || item.flkS1 || item.flkS2
                    }
                }
            })
        } else {
            for (const f of sumFields) {
                Object.defineProperty(item, f, {
                    get: function() {
                        return that.reSum(item, f)
                    }
                })
            }
            Object.defineProperties(item, {
                'flk1': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk1)
                    }
                },
                'flk2': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk2)
                    }
                },
                'flk3': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk3)
                    }
                },
                'flk1t': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk1t)
                    }
                },
                'flk2t': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk2t)
                    }
                },
                'flk3t': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flk3t)
                    }
                },
                'flkS1': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flkS1)
                    }
                },
                'flkS2': {
                    get: function() {
                        return item.child_list.some((v: any) => v.flkS2)
                    }
                },
                'flk': {
                    get: function() {
                        return item.flk1 || item.flk2 || item.flk3 || item.flk1t || item.flkS1 || item.flkS2
                    }
                }
            })
        }

    }
    private flkAgree() {
        let isValid = true
        for (const ppr of this.tableData) {

            if (ppr.flk) {
                isValid = false
                break
            }
        }
        return isValid
    }
    private async updateFormFlk() {
        if (this.childStatus && this.childStatus.hasOwnProperty('code') && this.childStatus.code) return
        const req:any = {
            flk: !this.flkAgree(),
            form_id: this.currForm.id
        }
        await axios.post('/api-py/input-forms/flk', req).catch(e => {})
    }

    private get downloadList() {
        const reportList: any[] = []
        if (this.currForm.form_code === 'app12') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [2],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}_rb`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app12cons') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [2],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}_rb`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app14_rb') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [2],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}_rb`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app14cons_rb') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [2],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}_rb`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app14_ob') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app14cons_ob') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
        }
        if (this.currForm.form_code === 'app18') {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}`),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [20],
                name: this.$t(`${this.tr_path}.download_rep.btn_${this.currForm.form_code}_p20`),
                idx: reportList.length
            })

        }

        return reportList
    }

    private reasonText(id:number) {
        const it = this.reasonsFull.find((v:any) => v.id === id)
        const l_name = `name_${this.$i18n.locale}`
        if (it) return it[l_name]
        else return 1
    }

    private onSaveReason() {

    }
    private async onBack() {
        return true
    }

    private onReasonBack() {
        this.showReasonInput = false;
        this.$emit('onCloseReasons');
    }

    private noAbc: Function = noAbc
    private nextInput: Function = nextInput

    private getNextInputIndx(prgIdx: number, pprIdx: number, spfIndx: number, chldIndx: number | null) {
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }
    private inputFixed(item: any, field: any, value: any, digit: any) {
        item.hasChanges = true
        if (value) {
            this.$set(item, field, parseFloat(parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, '')).toFixed(digit)));
        } else {
            this.$set(item, field, 0);
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
}
